<template>
  <div class="row">
    <div class="col-12 col-lg-5 c g">
        <div class="card card-body">
            <div class="form-group">
                <h5 for="">اسم المدرسة</h5>
                <input type="text" v-model="schoolname" class="form-control" @change="save()">
            </div>
            <div class="form-group">
                <h5 for="">اسم مدير المدرسة</h5>
                <input type="text" v-model="adminname" class="form-control" @change="save()">
            </div>
            <hr>
            <button v-b-modal.s1 @click="getStudents()" class="btn btn-block btn-default" style="margin-top: 5px; border: solid 2px green; background: #fafafa;">
                نموذج الالتزام المدرسي <button class="btn btn-sm btn-danger" style="padding: 3px"><i class="fa fa-star"></i> جديد</button>
            </button>
            <button v-for="a in arr" @click="open(a)" :key="a.title" class="btn btn-block btn-default" style="margin-top: 5px; border: solid 2px #ddd; background: #fafafa;">
                {{ a.title }}
            </button>
        </div>
    </div>
    <b-modal id="s1" title="نموذج الالتزام المدرسي" hide-footer size="lg">
        <div>
            <p>اختر المراد الطباعة لهم</p>
            <div class="row">
                <div class="col-12 col-lg-6 g">
                    <button class="btn btn-block btn-primary" @click="way = 'single'">
                        <i class="fa fa-users"></i>
                        اختر فردياً
                    </button>
                </div>
                <div class="col-12 col-lg-6 g">
                    <button class="btn btn-block btn-success" @click="way = 'bulk'">
                        <i class="fa fa-users"></i>
                        اختر من الفصول
                    </button>
                </div>
            </div>
        </div>
        <div v-if="way == 'single' || way == 'attend'">
            <div class="g">
                اختر الطلاب <input type="text" placeholder="ابحث هنا..." v-model="q" @change="getStudents()" @keyup="getStudents()" style="border: none; border: 1px solid #999; padding: 5px"> <button class="btn btn-sm"><i class="fa fa-search"></i> بحث</button>
            </div>
            <div style="width: 100%; border: solid 2px #333; padding: 5px; overflow-y: scroll; height: 250px;">
                <div class="form-check" v-for="student in students" :key="student._id">
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="selected" :value="student">
                    {{ student.name }}
                </label>
                </div>
            </div>
        </div>
        <div v-if="way == 'bulk'">
            <div>
                اختر الفصول <a href="javascript:;" @click="xxxc()">
                    <i class="fa fa-check-square"></i>
                    اختيار الكل
                </a>
                <br><br>
            </div>
            <div class="form-check" v-for="c in classrooms" :key="c">
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input ascddsd" @change="classChanges(c)" v-model="selected_classrooms" :value="c">
                    {{ c }}
                </label>
                <div class="card-body">
                    <div class="border g" style="overflow-y: scroll; height: 100px">
                        <template v-for="student in students">
                            <div v-if="student.classname + ' - ' + student.classroom == c" class="form-check" :key="student._id">
                                <label class="form-check-label">
                                    <input type="checkbox" class="form-check-input" v-model="selected" :value="student">
                                    {{ student.name }}
                                </label>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer" v-if="way && selected.length > 0">
            <div class="row">
                <div class="col-12 col-lg-6 g c">
                    <button class="btn btn-success btn-block" @click="sendd=false;print()">
                        <i class="fa fa-print"></i>
                        طباعة النموذج
                    </button>
                </div>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal, BDropdown, BDropdownItem, BFormCheckbox } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BDropdown,
        BDropdownItem,
        BModal,
        BFormCheckbox
    },
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            schoolname: "",
            adminname: "",
            sendd: false,
            students: [],
            selected: [],
            way: false,
            q: null,
            selected_classrooms: [],
            classrooms: [],
            gover: "",
            school: "",
            stage: "",
            arr: [{"title":"نموذج فارغ للمدرسة","id":1,"custom":true},{"title":"سجل مشتريات المدرسة","id":2,"custom":true},{"title":"طلب ( إصدار /  إلغاء /  تعديل  ) وثيقة","id":3,"custom":true},{"title":"اسم النموذج :  استمارة دعم وتطوير الهيئة التعليمية","id":4,"custom":true},{"title":"اسم النموذج : استمارة موافقة ولي أمر الطالب للاشتراك في النقل المدرسي","id":5,"custom":true},{"title":"اسم النموذج : إشعار موعد التدقيق الداخلي","id":6,"custom":true},{"title":"اسم النموذج : الخطة الفصلية للتجارب العلمية","id":7,"custom":true},{"title":"اسم النموذج : أمر مطالبة","id":8},{"title":"اسم النموذج : بيان اطلاع الموظفين على التعاميم","id":9},{"title":"بيان اطلاع الموظفين على تقويم الاداء الوظيفي","id":10},{"title":"اسم النموذج : تسليم نسخ موثقة","id":11},{"title":"اسم النموذج : تقرير التدقيق الداخلي","id":12,"custom":true},{"title":"اسم النموذج : جرد المعامل","id":13},{"title":"اسم النموذج : خطة التدقيق الداخلي النصف سنوية","id":14},{"title":"اسم النموذج : خطة الزيارات الصفية لقائد المدرسة","id":15},{"title":"اسم النموذج : سجل زيارات الفصول","id":16},{"title":"اسم النموذج : سجل استئذان الموظفين","id":17},{"title":"اسم النموذج : سجل استعارة كتب للطلاب","id":18},{"title":"اسم النموذج : سجل التردد اليومي","id":20},{"title":"اسم النموذج : سجل الصادر العام","id":21},{"title":"اسم النموذج : سجل العمل الرسمي","id":22},{"title":"اسم النموذج : سجل الوارد العام","id":23},{"title":"اسم النموذج : سجل تنفيذ التجارب العملية","id":24},{"title":"اسم النموذج : سجل توديع المعاملات","id":25},{"title":"اسم النموذج : سجل جرد المختبر والمواد الكيميائية","id":26,"custom":true},{"title":"اسم النموذج : سجل حصر الناقص والزائد والتالف في المختبر","id":27},{"title":"اسم النموذج : سجل طلبات إجراءات تصحيحية","id":28},{"title":"اسم النموذج : طلب صيانة","id":29},{"title":"اسم النموذج : عدم المطابقة","id":30},{"title":"قرار حسم غياب","id":31},{"title":"اسم النموذج : قرار حسم مجموع ساعات تأخر وخروج مبكر","id":33},{"title":"اسم النموذج : قياس اتجاهات المتعلمين نحو المدرسة","id":34,"custom":true},{"title":"اسم النموذج : كشف بموجودات المستودع العام للمدرسة","id":35},{"title":"اسم النموذج : محضر فقد أو إتلاف مواد","id":36},{"title":"اسم النموذج : مساءلة غياب","id":37},{"title":"اسم النموذج : نموذج التدقيق الداخلي","id":38},{"title":"اسم النموذج :سجل استلام عهدة","id":39},{"title":"اسم النموذج: تقويم الأداء الوظيفي لشاغلي الوظائف الإدارية","id":40,"custom":true},{"title":"اسم النموذج: تنبيه عن تأخر / انصراف","id":41},{"title":"اسم النموذج: نموذج تقويم الأداء الوظيفي لشاغلي الوظائف التعليمية","id":42,"custom":true},{"title":"اسم النموذج: التقرير الاسبوعي لقائد المدرسة من وكيل المدرسة للشؤون المدرسية","id":43}]
        }
    },
    created(){
        if(!checkPer("mentors")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        this.schoolname = localStorage.getItem("mentors_schoolname") ?? "";
        this.adminname = localStorage.getItem("mentors_adminname") ?? "";

            $.post(api + '/user/students/classes', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    r.response.forEach(function(a){
                        a.classrooms.forEach(function(b){
                        g.classrooms.push(a.title + ' - ' + b)
                    })
                    })
                }
            }).fail(function(){
            })
    },
    methods: {
        print(){
            var g = this;
            var html = "";
            var win = window.open("");
            g.selected.forEach(function(bi){
            html = html + (`
                <div class='container'>
                <div class="row" style='padding-top: 10px'>
                    <div class="col-4 text-center">
                    <p><Br><Br>
                        المملكة العربية السعودية
                        <br>
                        وزارة التعليم
                    </p>
                    </div>
                    <div class="col-4 text-center"><br>
                    <img style="width: 150px !important;" src="https://cdn-static.brmja.com/storage/scrapped/62793ceb03c19132886968.jpg">
                    </div>
                    <div class="col-4 text-center"><br><Br>
                    <p style='padding-top: 5px'>
                    المنطقة/المحافظة: ${g?.user?.settings?.gover ?? g.user.location}
                    <br>
                    المدرسة: ${g.user.name}
                    </p>
                    </div>
                    <div class='col-12 text-center'>
                    <h4>نموذج الالتزام المدرسي</h4>
                    <br>
                    </div>
                    <div class='col-12'>
                        <table class='table table-bordered table-lg'>
                            <tbody>
                                <tr>
                                    <td style='padding: 10px'>
                                        <br><Br>
                                        خاص <br>
                                        بالطالب / الطالبة
                                    </td>
                                    <td style='padding: 10px'>
                                        الاسم: ${bi.name}
                                        <br><br>
                                        الصف: ${bi.classname}
                                        <br><br><br>
                                        <p>نعم أنا الطالب/الطالبة الموضح اسمه وبياناته أعلاه. قد اطلعت على محتوى قواعد السلوك والمواظبة، وبناء عليه أتعهد أن ألتزم بالأنظمة والتعليمات الخاصة بقواعد السلوك والمواظبة.</p>
                                        التوقيع: .................................................
                                        &nbsp;&nbsp; التاريخ :  &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; 14 هـ
                                    </td>
                                </tr>
                                <tr>
                                    <td style='padding: 10px'>
                                        <br><Br>
                                        خاص بولي الأمر
                                    </td>
                                    <td style='padding: 10px'>
                                        <p>
                                        نعم أنا ولي أمر الطالب/الطالبة الموضح اسمه وبياناته أعلاه. قد اطلعت على محتوى قواعد السلوك والمواظبة، وبناء عليه أتعهد أن أتعاون مع إدارة المدرسة في سبيل مصلحة ابني/ابنتي، ليكون ملتزماً بالأنظمة والتعليمات الخاصة بقواعد السلوك والمواظبة، وأتحمل مسؤولية صحة أرقام التواصل التالية:
                                        </p>
                                        الاسم: .................................................
                                        <br><br>
                                        التوقيع: ................................................. 
                                        &nbsp;&nbsp;
                                        التاريخ :  &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; 14 هـ
                                        <br><br>
                                        العمل: .................................................
                                        &nbsp;&nbsp;
                                        هاتف العمل: .................................................
                                        <br><br>
                                        هاتف المنزل: .................................................
                                        &nbsp;&nbsp;
                                        رقم الجوال: .................................................
                                        <br><br>
                                        رقم آخر: .................................................
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class='col-12' style='padding: 10px'></div>
                    <div class='col-6' style='position:relative'>
                        ملحوظة:
                        <Br>
                        <ul>
                            <li>يؤخذ توقيع الطالب وولي الأمر في بداية العام الدراسي.</li>
                            <li>تحفظ النماذج في ملف خاص لدى وكيل/وكيلة شؤون الطلبة.</li>
                        </ul>
                        <img src='https://app.naqar.net/bis-qrcode.png' style='position: absolute; left: -250px;top: -20px; width: 200px'>
                    </div>
                </div>
                </div>
            `)
                
            })
            win.document.write(`
            <html dir="rtl">
                <head>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css">
                <style>
                    .bg-dark{
                    background: #DDDDDD !important
                    }
                        .container{
                        page-break-after:always;
                        }
                        @media print {
                        @page {
                        margin: 0;
                    }
                        .print{display:none}}
                        @page {
                        margin: 0;
                    }
                    @media print {
                    @page {
                        margin: 0 !important;
                        padding: 0px;
                    }
                    }
                </style>
                </head>
                <body>
                ${html}
                </body>
            </html>
            `)
            win.document.close()
            setTimeout(() => {
                win.print()
            }, 1000);
            win.document.designMode = "on"
        },
        xxxc(){
            $(".ascddsd").each(function(){
                $(this).click()
            })
        },  
        classChanges(cc){
            var g = this;
            g.students.forEach(function(a){
                if(g.selected_classrooms.includes(a.classname + ' - ' + a.classroom) && cc == a.classname + ' - ' + a.classroom){
                    g.selected.push(a)
                }
                if(!g.selected_classrooms.includes(a.classname + ' - ' + a.classroom)){
                    g.selected = g.selected.filter(function(x){
                        if(!g.selected_classrooms.includes(x.classname + ' - ' + x.classroom)){
                            return false;
                        }else{
                            return x;
                        }
                    })
                }
            })
        },
        getStudents(){
            var g = this;
            $.post(api + '/user/students/list', {
                jwt: g.user.jwt,
                page: 1,
                q: this.q,
                perpage: 11111
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.students = r.response
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        save(){
            localStorage.setItem("mentors_schoolname", this.schoolname);
            localStorage.setItem("mentors_adminname", this.adminname);
        },
        open(a){
            window.open(`https://naqar.net/api/views/kshof.${a.custom ? a.id + '?t' : 'general?id=' + a.id}&school_name=${encodeURI(this.schoolname)}&admin_name=${encodeURI(this.adminname)}`)
        }
    }
}
</script>

<style>

</style>